import '../../../style/index';
import './index.less';
